import axios from 'axios';

const list = (data) => axios.get('/pro/energy/list', data);
const save = (data) => axios.post('/pro/energy/save', data);
const del = (data) => axios.post('/pro/energy/delete', data);


export default {
  list,
  save,
  del,

}


